import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import i18n from "../../../../plugins/i18n/i18n";
import { errorMessageNotification, isMobile } from "../../../../helpers";
import { Form, Row, Col, Button, Input, notification as Notification } from "antd";

class ChangePassword extends Component {

    constructor(props) {
        super(props);

        this.endpoint = { keyOne: "account", keyTwo: "changepassword" };
        this.state = {
            form: {},
            loadings: {
                submit: false,
                data: false,
                proxyuser: false,
                proxyusersubmit: false,
                search: false
            },
            isShowModal: false,
            values: {
                proxyUsers: []
            }
        };
        this.proxyUserFormRef = React.createRef();
        this.formRef = React.createRef();

    }

    componentWillMount() {
        if (isMobile()) {
            this.setState({
                isResponsive: true,
            });
        }
    }

    fetch = (values) => {

        let { loadings } = this.state;

        var param = values;
        loadings.submit = true;
        this.setState({ loadings });

        this.props
            .dispatch(
                actions.definitions.addData({
                    ...this.endpoint,
                    data: param,
                })
            )
            .then((response) => {
                loadings.submit = false;

                this.setState({
                    loadings,
                });

                Notification.success({
                    message: errorMessageNotification(response),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 3,
                });
                this.formRef.current.resetFields();
            })
            .catch((error) => {
                loadings.submit = false;
                this.setState({ loadings });

                Notification.error({
                    message: i18n.t(`error`, {
                        lng: this.props.currentLanguage,
                    }),
                    description: errorMessageNotification(error),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 100,
                });

                setTimeout(() => {
                    Notification.destroy();
                }, 3000);
            });
    };



    render() {

        return (

            <div className="form-container change-password">
                <div className='heading'><strong>{`Şifre Değiştirme`}</strong></div>

                {
                    <Form layout="vertical" className='form-box' ref={this.formRef}
                        onFinish={this.fetch}>

                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item
                                    label={`${i18n.t("Mevcut Şifreniz", {
                                        lng: this.props.currentLanguage,
                                    })}`}
                                    name="currentPassword"
                                    rules={[
                                        {
                                            required: true,
                                            message: `${i18n.t("fieldIsRequired", {
                                                lng: this.props.currentLanguage,
                                            })}`,
                                        },
                                    ]}
                                >
                                    <Input.Password
                                        placeholder={i18n.t("Mevcut Şifreniz", {
                                            lng: this.props.currentLanguage,
                                        })}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item
                                    label={`${i18n.t("Yeni Şifre", {
                                        lng: this.props.currentLanguage,
                                    })}`}
                                    name="password"
                                    rules={[
                                        {
                                            required: true,
                                            message: `${i18n.t("fieldIsRequired", {
                                                lng: this.props.currentLanguage,
                                            })}`,
                                        },
                                    ]}
                                >
                                    <Input.Password
                                        placeholder={i18n.t("Yeni Şifre", {
                                            lng: this.props.currentLanguage,
                                        })}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item
                                    label={`${i18n.t("Şifre Tekrar", {
                                        lng: this.props.currentLanguage,
                                    })}`}
                                    name="confirmPassword"
                                    rules={[
                                        {
                                            required: true,
                                            message: `${i18n.t("fieldIsRequired", {
                                                lng: this.props.currentLanguage,
                                            })}`,
                                        },
                                    ]}
                                >
                                    <Input.Password
                                        placeholder={i18n.t("Şifre Tekrar", {
                                            lng: this.props.currentLanguage,
                                        })}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item className="form-item-submit">
                                    <Button
                                        htmlType="submit"
                                        type="primary"
                                        className="ant-btn width-100"
                                        style={{ height: 40 }}
                                        loading={this.state.loadings.submit}
                                    >
                                        Şifremi Değiştir
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>

                    </Form>
                }
            </div>
        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(ChangePassword);


// WEBPACK FOOTER //
// ./src/components/App/Views/Account/ChangePassword.js